export const EXIT_CODES = {
  SUCCESS: 0,
  ERROR: 1,
  ABORTED: 2,
  AUTH_FAILURE: 3,
  NETWORK_ERROR: 4,
  NOT_FOUND: 5,
} as const;
